export default "__VITE_ASSET__0UbEQi09__"